import { render } from "./RechargePoints.vue?vue&type=template&id=28e124b1&scoped=true"
import script from "./RechargePoints.vue?vue&type=script&lang=js"
export * from "./RechargePoints.vue?vue&type=script&lang=js"

import "./RechargePoints.vue?vue&type=style&index=0&id=28e124b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e124b1"]])

export default __exports__